<template>
    <div class="container mt-5">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="card shadow-lg">
                    <div class="card-header bg-white border-bottom text-center">
                        <h4>Code de vérification</h4>
                    </div>
                    <div class="card-body">
                        <p class="lead text-black">
                            <span v-if="sendText">Un nouveau</span>
                            <span v-else>Un</span> code de
                            vérification a été envoyé à votre adresse e-mail. Veuillez entrer le
                            code ci-dessous
                        </p>
                        <div class="form-group">
                            <input type="number" class="form-control" v-model="verificationCode"
                                   placeholder="Entrez votre code" required>
                            <small class="text-danger">{{ errorMessage }}</small>
                        </div>
                        <div class="d-flex justify-content-center align-items-center mt-4">
                            <div v-if="countdown > 0">
                                <i class="fas fa-clock fa-lg text-muted mr-2"></i>
                                <span class="text-muted font-weight-bold">{{ formatCountdown() }}</span>
                            </div>
                            <div class="text-danger text-center mt-3" v-else>
                                Le code de verification est expiré, veuillez cliquer sur le button dessous pour un
                                nouveau code
                            </div>
                        </div>
                        <div v-if="showVerifyButton" class="form-group text-center mt-4">
                            <button class="genric-btn btn-block warning btn-sm p-0 radius " @click="verifyCode"
                                    :disabled="loading">
                                <span v-if="!loading">Vérifier</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                        <div v-else class="form-group text-center mt-4">
                            <button class="genric-btn btn-block btn-sm warning p-0 radius " @click="resendCode"
                                    :disabled="loading">
                                <span v-if="!loading">Renvoyer</span>
                                <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            showVerifyButton: true,
            verificationCode: '',
            countdown: 180, // 3 minutes
            loading: false,
            intervalId: null,
            errorMessage: '',
            sendText: false,
        };
    },
    methods: {
        verifyCode() {
            this.loading = true;
            axios.post(`/check-verification-code/${this.id}`, {code: this.verificationCode})
                .then((res) => {
                    window.removeEventListener('beforeunload', this.warnBeforeUnload);
                    window.location.href = '/new-password/' + res.data.token;
                })
                .catch(error => {
                    this.errorMessage = error.response.data.errors.code[0];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        resendCode() {
            this.loading = true;
            this.verificationCode = '';
            axios.get(`/resend-verification-code/${this.id}`)
                .then(response => {
                    this.sendText = true;
                    this.showVerifyButton = true;
                    this.countdown = 180;
                    this.startTimer();
                })
                .catch(error => {
                    this.errorMessage = error.response.data.errors.code[0];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatCountdown() {
            let minutes = Math.floor(this.countdown / 60);
            let seconds = this.countdown % 60;
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            return `${minutes}:${seconds}`;
        },
        startTimer() {
            this.intervalId = setInterval(() => {
                if (this.countdown === 0) {
                    this.showVerifyButton = false;
                    clearInterval(this.intervalId);
                } else {
                    this.countdown--;
                }

            }, 1000);
        },
        warnBeforeUnload(event) {
            event.preventDefault();
            event.returnValue = 'Voulez-vous vraiment quitter la page ?';
        },
    },
    mounted() {
        this.startTimer();
        window.addEventListener('beforeunload', this.warnBeforeUnload);
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        window.removeEventListener('beforeunload', this.warnBeforeUnload);
    },
};
</script>